// gibbys-flash-sale-timer.js

function TimerCountdown(el) {
    this.timerElement = el;
    this.containerElement = this.timerElement.closest('.flash-sale-container');
    this.timerId = null;

    // Set initial time and start the timer if valid
    this.updateTime(this.timerElement.dataset.time);
}

TimerCountdown.prototype.updateTime = function(newTime) {
    // Clear any existing timer
    if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
    }

    // Hide the timer element while updating
    this.timerElement.style.visibility = 'hidden';

    // Update the time
    if (newTime) {
        this.time = new Date(newTime).getTime();
        this.checkInitialTime();
        this.timer();
    } else {
        this.hideTimer();
    }
};

TimerCountdown.prototype.render = function (days = '0', hours = '0', minutes = '0', seconds = '0') {
    let items = ``;
    
    if (days !== '0') {
        items += `<div class="item"><span class="item">${days < 10 ? '0' + days : days }</span>`;
        if (days == '1') {
            items += `<span class="title">day</span></div>`;
            items += `<div class="item pipe"> | </div>`;
        } else {
            items += `<span class="title">days</span></div>`;
            items += `<div class="item pipe"> | </div>`;
        }
    }
    
    items += `
        <div class="item"><span class="item">${hours < 10 ? '0' + hours : hours }</span><span class="title">hr.</span></div>
        <div class="item pipe"> | </div>
        <div class="item"><span class="item">${minutes < 10 ? '0' + minutes : minutes }</span><span class="title">min.</span></div>
        <div class="item pipe"> | </div>
        <div class="item"><span class="item">${seconds < 10 ? '0' + seconds : seconds }</span><span class="title">sec.</span></div>
    `;
    
    return items;
};

TimerCountdown.prototype.checkInitialTime = function () {
    const now = new Date().getTime();
    const distance = this.time - now;

    if (distance > 0) {
        this.timerElement.innerHTML = this.render(); // Clear the display immediately
        this.containerElement.style.display = 'block'; // Show container after setting the time
        this.timerElement.style.visibility = 'visible'; // Show the timer element
    } else {
        this.hideTimer();
    }
};

TimerCountdown.prototype.timer = function () {
    this.timerId = setInterval(() => {
        const now = new Date().getTime();
        const distance = this.time - now;
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (distance < 0) {
            clearInterval(this.timerId);
            this.hideTimer(); // Hide the element when the countdown reaches 0
        } else {
            this.timerElement.innerHTML = this.render(days, hours, minutes, seconds);
            this.timerElement.style.visibility = 'visible'; // Ensure the timer element is visible
        }
    }, 1000);
};

TimerCountdown.prototype.hideTimer = function () {
    
    this.containerElement.style.display = 'none'; // Hide the entire container
};

// Initialize the timer for the selected option on page load
const selectedOption = document.querySelector('.gibbys-flash');
const countdownEl = document.querySelector('.js-countdown-timer');
let timer;
if (selectedOption && countdownEl) {
    if (selectedOption.dataset.flash && selectedOption.dataset.p) {
        timer = new TimerCountdown(countdownEl);
        timer.updateTime(selectedOption.dataset.flash);
    } else {
        countdownEl.closest('.flash-sale-container').style.display = 'none';
    }
}

// Add event listener to update the timer when the selected option changes
document.querySelectorAll('.opt-btn').forEach(radio => {
    radio.addEventListener('change', function() {
        const selectedSpan = this.nextElementSibling.querySelector('span');
        if (selectedSpan && countdownEl) {
            const newFlashTime = selectedSpan.dataset.flash;
            const newPValue = selectedSpan.dataset.p;

            if (newFlashTime && newPValue) {
                countdownEl.dataset.time = newFlashTime;
                if (!timer) {
                    timer = new TimerCountdown(countdownEl);
                } else {
                    // Update the time first, and then show the timer
                    timer.updateTime(newFlashTime);
                }
            } else {
                timer.hideTimer(); // Hide the timer if either attribute is missing
            }
        }
    });
});
